module.exports = __webpack_public_path__ + "img/banner_Contactus.71890fa7.jpg";